import { topCrousel, announceCarousel } from "./components/Carousels.js?v=1.0.5";
import { submenuToggle } from "./components/Accordion.js?v=1.0.1";
import { facilitiesList } from "./components/TokatsuSystem.js?v=1.0.3";
import { HeaderGlobalMenu } from "./components/HeaderGlobalMenu.js?v=1.0.1";
import { HeaderH1 } from "./components/Header.js?v=1.0.1";
import { initAOS } from "./initAos.js?v=1.0.1";
import { setupScrollLinks } from "./components/scrollToElement.js?v=1.0.2";
import { AnimationUnderline } from"./components/AnimationUnderline.js?v=1.0.1";
import { AnimationTypewriter } from"./components/AnimationTypewriter.js?v=1.0.1";
// import { AnimationSequential} from "./components/AnimationSequential.js";

function handleBackNavigation() {
  const els = document.querySelectorAll(`.page-transition-fade-out`);
  els?els.forEach((el)=>el.remove()):``;
}
//ページに訪れるとき
function fadeInTransition() {

  window.addEventListener('popstate', function(event) {
    handleBackNavigation();
  });

  window.addEventListener('DOMContentLoaded', function() {
    //console.log(performance);

    if (performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD) {
        console.log('back');
        // ここに必要な処理を追加
        handleBackNavigation();

    }
  });
  setTimeout(()=>{
    document.querySelector(`div.page-transition`)?document.querySelector(`div.page-transition`).remove():``;
  }, 800);
}


// サードパーティスクリプトの読み込みをブロックする
function blockThirdPartyCookies() {
  console.log(`blockThirdPartyCookies`);

  // サードパーティのスクリプトを無効化
  const thirdPartyScripts = document.querySelectorAll('script[data-type="third-party"],noscript[data-type="third-party"]');
  thirdPartyScripts.forEach(script => {
    console.log(script);

    script.remove(); // スクリプトを削除
  });

  // サードパーティCookieの設定を無効化 (SameSite属性を利用)
  document.cookie = "myCookie=value; SameSite=Strict; Secure"; // サイト内でのみ使用可能に
}
// サードパーティスクリプトを有効化する
function allowThirdPartyCookies() {
  console.log(`allowThirdPartyCookies`);
  // サードパーティスクリプトを追加
  const thirdPartyScript = document.createElement('script');
  thirdPartyScript.src = "https://example.com/third-party-script.js"; // サードパーティのURL
  thirdPartyScript.async = true;
  document.head.appendChild(thirdPartyScript);

  // サードパーティCookieを許可 (SameSite属性をNone, Secureを必須に)
  document.cookie = "myThirdPartyCookie=value; SameSite=None; Secure"; // 他サイトでもCookieを利用可能に
}


document.addEventListener('DOMContentLoaded', function() {
  //blockThirdPartyCookies();


  topCrousel().then((response)=>{
    console.log(response);
    initAOS().then(AOS => {



      announceCarousel({ autoSlide: true, autoSlideDelay: 5000 });
      HeaderGlobalMenu();
      submenuToggle();
      facilitiesList();
      HeaderH1();
      fadeInTransition();
      AnimationUnderline();
      AnimationTypewriter();
      // AnimationSequential();
      const navHeight = document.getElementById(`gh_nav`).offsetHeight;
      const offset = navHeight?navHeight / 2:0; // スクロール位置を調整するオフセット値（ピクセル単位）
      setupScrollLinks(offset);

    })
  });
})

